namespace Matrix.Dashboards {
    export interface DatasetFetchRequest extends Serenity.ServiceRequest {
        AggregateFields?: AggregateField[];
        AggregateGroups?: string[];
        DatasetCode?: string;
        ExcludeData?: boolean;
        IncludeTotalCount?: boolean;
        Params?: { [key: string]: any };
        Sort?: string[];
        Skip?: number;
        Take?: number;
    }
}
